import { useContext, useState } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import { useNavigate } from "react-router-dom";
import img1 from "../../../assets/images/logo colegio (32).png";

function HeaderEmpleado() {
  const { empleado, logoutEmpleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!empleado) return null;

  const cerrarSesion = () => {
    logoutEmpleado();
    navigate("/loginEmpleados");
  };

  return (
    <nav
      className="navbar sticky-top px-3 shadow"
      style={{ background: "rgb(61, 102, 81)" }}
    >
      <div className="container-fluid d-flex align-items-center justify-content-between">

        {/* Logo + Texto */}
        <div className="d-flex align-items-center">
          <img
            src={img1}
            alt="Logo Colegio"
            style={{ height: "60px", width: "auto" }}
          />
          <div className="ms-3 text-home">
            <h1 className="mb-0 mt-2" id="texto-nav-homecolegio">
              Colegio Santo Tomás
            </h1>
            <p className="mb-0 text-center" id="texto-nav-home">
              Portal de Empleados
            </p>
          </div>
        </div>

        {/* Dropdown Usuario */}
        <div className="position-relative">
          <button
            className="btn text-white fw-semibold"
            style={{
              background: "rgba(255,255,255,0.15)",
              borderRadius: "20px"
            }}
            onClick={() => setOpen(!open)}
          >
            👤 {empleado.nombre} {empleado.apellido}
          </button>

          {open && (
            <div
              className="dropdown-menu dropdown-menu-end show shadow"
              style={{ position: "absolute", right: 0 }}
            >
              <button
                className="dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate("/dashboardEmpleados");
                }}
              >
                🏠 Dashboard
              </button>

              <button
                className="dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate(" ");
                }}
              >
                👁 Ver perfil
              </button>


              <hr className="dropdown-divider" />

              <button
                className="dropdown-item text-danger"
                onClick={cerrarSesion}
              >
                🚪 Cerrar sesión
              </button>
            </div>
          )}
        </div>

      </div>
    </nav>
  );
}

export default HeaderEmpleado;
